import middleEarReport from "./middleEarReport.vue";
export default middleEarReport;
